import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import BedroomsFilter from '../store/BedroomsFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';

export default class BedroomsConnector implements Observer {
    readonly #element: HTMLSelectElement;

    readonly #filter: BedroomsFilter;

    constructor(element: HTMLSelectElement, filter: BedroomsFilter) {
        this.#element = element;
        this.#filter = filter;

        this.#element.addEventListener('change', this.#updateFilter.bind(this));
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof BedroomsFilter)) {
            return;
        }

        this.#element.value = subject.parameters.bedrooms || '';
    }

    public static connectToElement(querySelector: string): void {
        const filters = HouseSearchFilters.getInstance();
        const element = document.querySelector(querySelector) as HTMLSelectElement | null;
        const filter = filters.get(BedroomsFilter.NAME) as BedroomsFilter | undefined;

        if (!element || !filter) return;

        const connector = new BedroomsConnector(element, filter);
        filter.attach(connector);
    }

    #updateFilter(): void {
        const value = this.#element.value !== '' ? this.#element.value : '0';
        this.#filter.bedrooms = Number(value);
    }
}
